import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/shared/services/menu.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-station-tab',
  templateUrl: './station-tab.component.html',
  styleUrls: ['./station-tab.component.scss']
})
export class StationTabComponent implements OnInit {

  public id;

  constructor(
    public menu: MenuService,
    public route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
  }
  
}
